import { h, Fragment } from 'preact'
import PropTypes from 'prop-types'
import { useState, useEffect } from 'preact/compat'
import { useDispatch, useSelector } from 'react-redux'
import {
  cardsDelete,
  cardSelect,
  cardsSelector,
} from '../../../redux/slice/cardsSlice'
import { selectIsPciFormEnabled } from '../../../redux/selectors/evervault'
import SavedCard from '../SavedCard'
import SelectButton from '../../Common/SelectButton'
import Modal from '../../Common/Modal'
import Loader from '../../Common/Loader'
import { deleteCards } from '../../../api/savedCards'
import { useTranslations } from '../../../hooks/useTranslations'

const CardsListDeletion = ({ onDeleteSuccess }) => {
  const l10n = useTranslations()
  const dispatch = useDispatch()
  const { savedCards } = useSelector(cardsSelector)
  const isPciEnabled = useSelector(selectIsPciFormEnabled)

  const [selectedCardsForDelete, setSelectedCardsForDelete] = useState([])

  const [isDeleting, setDeletingState] = useState(false)

  const selectCardForDelete = value => {
    if (selectedCardsForDelete.includes(value)) {
      setSelectedCardsForDelete(selectedCardsForDelete.filter(c => c !== value))
    } else {
      setSelectedCardsForDelete([...selectedCardsForDelete, value])
    }
  }

  const [isOpened, setIsOpened] = useState(false)

  const onDelete = e => {
    e.preventDefault()

    if (isPciEnabled) {
      window.parent?.postMessage?.(
        {
          type: 'MFEShowDeletionModalShow',
          data: {
            isManyCards: selectedCardsForDelete.length,
          },
        },
        '*',
      )
    } else {
      setIsOpened(true)
    }
  }

  const onDeleteConfirm = () => {
    setDeletingState(true)
    deleteCards(selectedCardsForDelete)
      .then(() => {
        dispatch(cardsDelete(selectedCardsForDelete))
        window.parent?.postMessage?.(
          {
            type: 'MFEStoreDispatch',
            data: {
              actionType: 'cardsDelete',
              message: selectedCardsForDelete,
            },
          },
          '*',
        )

        dispatch(
          cardSelect(savedCards.find(card => card?.isDefault) || savedCards[0]),
        )
        window.parent?.postMessage?.(
          {
            type: 'MFEStoreDispatch',
            data: {
              actionType: 'cardSelect',
              message:
                savedCards.find(card => card?.isDefault) || savedCards[0],
            },
          },
          '*',
        )

        onDeleteSuccess()
      })
      .finally(() => {
        setDeletingState(false)
        setIsOpened(false)
      })
  }

  const onDeleteCancel = () => {
    setIsOpened(false)
  }

  if (isDeleting) {
    return <Loader />
  }

  const handlePCIDetailsMessage = e => {
    const type = e?.data?.type

    if (type === 'PaymentsMFECardsDeletionConfirm') {
      onDeleteConfirm()
    }
  }

  useEffect(() => {
    window.addEventListener('message', handlePCIDetailsMessage)

    return () => window.removeEventListener('message', handlePCIDetailsMessage)
  }, [selectedCardsForDelete, savedCards])

  return (
    <>
      {savedCards.map(card => (
        <SelectButton
          key={card.id}
          name={card.maskedCardNumber}
          value={card.id}
          isChecked={selectedCardsForDelete.includes(card.id)}
          type="checkbox"
          className="card-select card clickable level-1"
          onChange={selectCardForDelete}
        >
          <SavedCard {...card} />
        </SelectButton>
      ))}
      <div className="card-list-actions delete-actions">
        <button
          type="button"
          disabled={selectedCardsForDelete.length === 0}
          className="button primary medium action-button"
          onClick={onDelete}
          data-testid="delete-button"
        >
          {l10n.t('Delete')}
        </button>
      </div>
      <Modal
        isOpened={isOpened}
        onConfirm={onDeleteConfirm}
        onCancel={onDeleteCancel}
        title={l10n.t(selectedCardsForDelete.length > 1 ? 'Delete cards' : 'Delete card')}
        cancelButtonText={l10n.t(selectedCardsForDelete.length > 1 ? 'Keep Cards' : 'Keep Card')}
        confirmButtonText={l10n.t('Delete')}
      >
        <>
          <div className="card-deletion-confirm-area">
            <h4 className="lead">
              {l10n.t(selectedCardsForDelete.length > 1 ? 'Are you sure you want to delete these cards?' : 'Are you sure you want to delete this card?')}
            </h4>
            <p>
              {l10n.t(selectedCardsForDelete.length > 1 ? 'To remove these cards from your ‘saved cards’ list, click ‘delete’': 'To remove this card from your ‘saved cards’ list, click ‘delete’')}
            </p>
          </div>
        </>
      </Modal>
    </>
  )
}

CardsListDeletion.propTypes = {
  onDeleteSuccess: PropTypes.func.isRequired,
}

export default CardsListDeletion
